export const GET_ACTM_ACCOUNT_SETTING_BY_BRANCH_ID = 'GET_ACTM_ACCOUNT_SETTING_BY_BRANCH_ID'
